module.exports = __webpack_public_path__ + "media/images/good-d0c33f64.svg";